import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {HandleService} from "./handleService";
import {ComponentUIServiceVisibilityInterface} from "../../interfaces/ComponentUIServiceVisibilityInterface";
import {AppStateService} from "../../services/appStateService";

export class HandleUIService implements ComponentUIServiceVisibilityInterface
{
    private uiService: UIService;
    private productDataService: ProductDataService;
    private handleService: HandleService;
    private productDataStore: ProductDataStore;
    private appStateService: AppStateService;

    constructor()
    {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.handleService = new HandleService();
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
        this.handleService.refreshComponentTemplate();
        this.initializeModal();
        this.populatePreview();
        // this.uiService
        //     .getResetButtonByModule('handle')
        //     .addEventListener('click', (event: any) => {
        //         this.handleService.reset();
        //         this.refreshSelectedOptions();
        //         this.productDataService.refreshPrice();
        //     });
        this.setPartDiscountImage();
    }

    componentDontHaveOptions(): boolean {
        return this.productDataStore.getAvailableOptionsByName('handle').length === 0;
    }

    private populatePreview()
    {
        const selectedInsideHandleElements = this.uiService.getElementByActionName('selected-insideHandle');
        const selectedOutsideHandleElements = this.uiService.getElementByActionName('selected-outsideHandle');

        const handles = this.productDataStore.getAvailableOptionsByName('handle');

        const selectedOutsideHandleId = this.productDataStore.getSelectedOptionIdByName('handleOutside');
        const selectedInsideHandleId = this.productDataStore.getSelectedOptionIdByName('handleInside');

        selectedInsideHandleElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });
        selectedOutsideHandleElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });

        handles.forEach((handle) => {
            if (selectedInsideHandleId === handle.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            handle.attributes.name
                        )
                    );

                this.uiService.addHtmlInElement(
                    this.uiService.getElementByAttribute(
                        'nf-action',
                        'selected-insideHandle'
                    ),
                    element.innerHTML
                );
            }
            if (selectedOutsideHandleId === handle.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            handle.attributes.name
                        )
                    );

                this.uiService.addHtmlInElement(
                    this.uiService.getElementByAttribute(
                        'nf-action',
                        'selected-outsideHandle'
                    ),
                    element.innerHTML
                );
            }
        });
    }

    private initializeModal()
    {
        const closeButton = document
            .querySelector('.configuratorComponent[nf-component-name="handles"]')
            .querySelector(`[nf-action="closeHandleDetailsModal"]`);

        closeButton.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('handles', 'handleDetailsModal', false);
            this.uiService.refreshElementsInModule('handles');
        });
    }

    public refreshSelectedOptions()
    {
        const outsideHandleId = this.productDataStore.getSelectedOptionIdByName('handleOutside');
        const insideHandleId = this.productDataStore.getSelectedOptionIdByName('handleInside');
        const handlePositionId = this.productDataStore.getSelectedOptionIdByName('handlePosition');
        const handleOptions = this.productDataStore.getSelectedOptionIdByName('handleOptions');

        this.uiService.resetSelectionsByPartName('insideHandle');
        this.uiService.resetSelectionsByPartName('outsideHandle');
        this.uiService.resetSelectionsByPartName('handlePosition');
        this.uiService.resetSelectionsByPartName('handleOption');

        if (insideHandleId) {
            this.uiService.setSelectedOption(
                this.uiService.getElementByPartNameAndId(
                    'insideHandle',
                    insideHandleId
                )
            );
        }
        if (outsideHandleId) {
            this.uiService.setSelectedOption(
                this.uiService.getElementByPartNameAndId(
                    'outsideHandle',
                    outsideHandleId
                )
            );
        }
        if (handlePositionId) {
            this.uiService.setSelectedOption(
                this.uiService.getElementByPartNameAndId(
                    'handlePosition',
                    handlePositionId
                )
            );
        }
        if (handleOptions) {
            handleOptions.forEach((handleOptionId) => {
                this.uiService.setSelectedOption(
                    this.uiService.getElementByPartNameAndId(
                        'handleOption',
                        handleOptionId
                    )
                );
            });
        }
    }

    public initializeHandleComponent()
    {
        if (this.componentDontHaveOptions()) {
            this.appStateService.setAppSettingTemplateFlag('app', 'handlesComponent', false);
            this.uiService.refreshElementsInModule('app');
            this.uiService.hideConfiguratorMenuElement('handles');
            return;
        }

        const handleOptions = this.productDataStore.getAvailableOptionsByName('handleOptions');

        handleOptions.forEach((handleOption) => {
            const option = this.createHandleOption(handleOption);

            if (this.productDataStore.getSelectedOptionIdByName('handleOptions').includes(handleOption.id)) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                this.handleService.toggle('handleOptions', handleOption.id);
                this.refreshSelectedOptions();
            });
        });

        this.initializeInsideHandle();
        this.initializeOutsideHandle();
        this.initializeHandlePositions();
    }

    /**
     * Inside handle is default handle accross our system
     * that means that if product cannot have different handles on both sides
     * we only select inside handle and assume that outside handle is the same
     */
    private initializeInsideHandle()
    {
        const handles = this.productDataStore.getAvailableOptionsByName('handle');
        const insideHandles = handles.filter(handle => handle.attributes.can_be_inside === true);

        if (Object.keys(insideHandles).length === 0) {
            return false;
        }

        insideHandles.forEach((handle) => {
            const option = this.createHandle('insideHandle', handle);
            const readMoreButton = option.querySelector(`[nf-action="openHandleDetailsModal"]`);

            if (handle.id === this.productDataStore.getSelectedOptionIdByName('handleInside')) {
                this.uiService.setSelectedOption(option);
            }

            if (readMoreButton !== null) {
                readMoreButton.classList.remove('--hiddenTemplateElement');
                readMoreButton.addEventListener('click', (event: any) => {
                    this.uiService.replaceTextInElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'modalTitle',
                            document.querySelector(
                                '.configuratorComponent[nf-component-name="handles"]'
                            ),
                        ),
                        handle.attributes.name
                    );
                    this.uiService.setAttributeToElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'modalImg',
                            document.querySelector(
                                '.configuratorComponent[nf-component-name="handles"]'
                            ),
                        ),
                        'src',
                        handle.attributes.imgSrc
                    );
                    this.appStateService.setAppSettingTemplateFlag('handles', 'handleDetailsModal', true);
                    this.uiService.refreshElementsInModule('handles');

                    event.preventDefault();
                    event.stopPropagation();

                    return false;
                });
            }

            option.addEventListener('click', (event: any) => {
                this.uiService.resetSelectionsByPartName('insideHandle');
                this.uiService.setSelectedOption(event.currentTarget);
                this.productDataService.updateSelectedOptionByName('handleInside', handle.id, true);
                this.populatePreview();
            });
        });
    }

    private initializeOutsideHandle()
    {
        const handles = this.productDataStore.getAvailableOptionsByName('handle');
        const outsideHandles = handles.filter(handle => handle.attributes.can_be_outside === true);

        if (Object.keys(outsideHandles).length === 0) {
            return false;
        }

        outsideHandles.forEach((handle) => {
            const option = this.createHandle('outsideHandle', handle);
            const readMoreButton = option.querySelector(`[nf-action="openHandleDetailsModal"]`);

            if (handle.id === this.productDataStore.getSelectedOptionIdByName('handleOutside')) {
                this.uiService.setSelectedOption(option);
            }

            if (readMoreButton !== null) {
                readMoreButton.classList.remove('--hiddenTemplateElement');
                readMoreButton.addEventListener('click', (event: any) => {
                    this.uiService.replaceTextInElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'modalTitle',
                            document.querySelector(
                                '.configuratorComponent[nf-component-name="handles"]'
                            ),
                        ),
                        handle.attributes.name
                    );
                    this.uiService.setAttributeToElement(
                        this.uiService.getElementByAttribute(
                            'nf-value-key',
                            'modalImg',
                            document.querySelector(
                                '.configuratorComponent[nf-component-name="handles"]'
                            ),
                        ),
                        'src',
                        handle.attributes.imgSrc
                    );
                    this.appStateService.setAppSettingTemplateFlag('handles', 'handleDetailsModal', true);
                    this.uiService.refreshElementsInModule('handles');

                    event.preventDefault();
                    event.stopPropagation();

                    return false;
                });
            }

            option.addEventListener('click', (event: any) => {
                this.uiService.resetSelectionsByPartName('outsideHandle');
                this.uiService.setSelectedOption(event.currentTarget);
                this.productDataService.updateSelectedOptionByName('handleOutside', handle.id, true);
                this.populatePreview();
            });
        });
    }

    private initializeHandlePositions()
    {
        const handlePositions = this.productDataStore.getAvailableOptionsByName('handlePosition');

        handlePositions.forEach((handlePosition) => {
            const option = this.createHandlePositionElement(handlePosition);

            if (this.productDataStore.getSelectedOptionIdByName('handlePosition') === handlePosition.id) {
                this.uiService.setSelectedOption(option);
            }
            option.addEventListener('click', (event: any) => {
                this.uiService.resetSelectionsByPartName('handlePosition');
                this.uiService.setSelectedOption(event.currentTarget);
                this.productDataService.updateSelectedOptionByName(
                    'handlePosition',
                    handlePosition.id,
                    true,
                    true
                );
                this.populatePreview();
            });
        });
    }

    private createHandleOption(handleOption) {
        const option = this.uiService.createConfiguratorOption('handleOption');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            handleOption.id
        );
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'fullImg',
                option,
            ),
            'href',
            handleOption.attributes.fullImgSrc
        );
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'img',
                option,
            ),
            'src',
            handleOption.attributes.imgSrc
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'name',
                option,
            ),
            handleOption.attributes.name
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'subtitle',
                option,
            ),
            handleOption.attributes.subtitle
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'currentPrice',
                option,
            ),
            '+' + handleOption.attributes.priceAfterDiscount + ' kr'
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'netPrice',
                option,
            ),
            '+' + handleOption.attributes.netPriceAfterDiscount + ' kr'
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'regularCustomerPrice',
                option,
            ),
            '+' + handleOption.attributes.regularPriceAfterDiscount + ' kr'
        );
        return option;
    }

    private createHandle(templateName, handle)
    {
        const option = this.uiService.createConfiguratorOption(templateName);

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            handle.id
        );
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'img',
                option,
            ),
            'src',
            handle.attributes.imgSrc
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'name',
                option,
            ),
            handle.attributes.name
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'price',
                option,
            ),
            '+' + handle.attributes.priceAfterDiscount + ' kr'
        );
        return option;
    }

    private createHandlePositionElement(handlePosition)
    {
        const option = this.uiService.createConfiguratorOption('handlePosition');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            handlePosition.id
        );
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'img',
                option,
            ),
            'src',
            handlePosition.attributes.img
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'name',
                option,
            ),
            handlePosition.attributes.name
        );
        if (handlePosition.attributes.price > 0) {
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'price',
                    option,
                ),
                '+' + handlePosition.attributes.price + ' kr'
            );
        }
        // @todo: add net price

        return option;
    }

    private setPartDiscountImage() {
        const partDiscountImageUrl = this.productDataService.getPartDiscountBannerByModule('handle');

        if (partDiscountImageUrl) {
            this.uiService.setAttributeToElement(
                this.uiService.getElementByAttribute('nf-template-flag', 'handlePartDiscountBanner'),
                'src',
                partDiscountImageUrl
            );

            this.appStateService.setAppSettingTemplateFlag('handles', 'handlePartDiscountBanner', true);
            this.uiService.refreshElementsInModule('handles');
        }
    }
}
